import * as styles from './marketingFeaturesWidgetPreviewCssDefs';
import { Button } from 'ui';
import { consumer } from '@tock/coretypes';
import { useTheme } from '@emotion/react';
import React, { FunctionComponent } from 'react';
import clsx from 'clsx';

interface MarketingFeaturesWidgetPreviewProps {
  tiles: consumer.IMarketingFeatureTile[];
}

export const MarketingFeaturesWidgetPreview: FunctionComponent<
  React.PropsWithChildren<MarketingFeaturesWidgetPreviewProps>
> = ({ tiles }) => {
  const theme = useTheme();
  const [scale, setScale] = React.useState<number>(0.5);

  return (
    <>
      <Button
        color="secondary"
        size="small"
        type="button"
        variant={scale === 0 ? 'contained' : 'outlined'}
        onClick={() => setScale(0)}
      >
        Hide Preview
      </Button>
      &nbsp;
      <Button
        color="secondary"
        size="small"
        type="button"
        variant={scale === 0.5 ? 'contained' : 'outlined'}
        onClick={() => setScale(0.5)}
      >
        Half Size
      </Button>
      &nbsp;
      <Button
        color="secondary"
        size="small"
        type="button"
        variant={scale === 0.75 ? 'contained' : 'outlined'}
        onClick={() => setScale(0.75)}
      >
        3/4 Size
      </Button>
      &nbsp;
      <Button
        color="secondary"
        size="small"
        type="button"
        variant={scale === 1 ? 'contained' : 'outlined'}
        onClick={() => setScale(1)}
      >
        Full Size
      </Button>
      {scale > 0 && (
        <div css={styles.root(theme)} style={{ '--scale': scale } as React.CSSProperties}>
          <div css={styles.desktopRoot(theme)}>
            <div css={styles.desktopItems(theme)}>
              {(tiles ?? []).map(({ imageUrl, title, text, link }, index) => (
                <div
                  className={clsx({
                    featureDesktopOfFive: tiles.length === 5,
                    featureDesktopOfFour: tiles.length === 4,
                    featureDesktopOfThree: tiles.length === 3,
                    featureDesktopOfTwo: tiles.length === 2,
                  })}
                  css={styles.desktopItem(theme)}
                  key={`${link}-${index}`}
                >
                  <a href={link || '#'} target="_blank" rel="noreferrer">
                    <div
                      className="MarketingFeature-backdrop"
                      style={{
                        backgroundImage: imageUrl ? `url('${imageUrl}')` : undefined,
                      }}
                    />
                    <div className="MarketingFeature-meta">
                      <h1 css={styles.desktopTitle(theme)}>{title}</h1>
                      <p css={styles.desktopDescription(theme)}>{text}</p>
                    </div>
                  </a>
                </div>
              ))}
            </div>
          </div>

          <div css={styles.mobileRoot(theme)}>
            <div css={styles.mobileItems(theme)}>
              <div className="scroll-area">
                {(tiles ?? []).map(({ imageUrl, title, text, link }, index) => (
                  <div key={`${link}-${index}`} css={styles.mobileItem(theme)}>
                    <a href={link || '#'} target="_blank" rel="noreferrer">
                      <div className="MarketingFeature-backdrop-wrapper">
                        <div
                          className="MarketingFeature-backdrop"
                          style={{ backgroundImage: imageUrl ? `url('${imageUrl}')` : undefined }}
                        />
                      </div>
                      <div className="MarketingFeature-content-wrapper">
                        <div className="MarketingFeature-meta">
                          <h1 css={styles.mobileTitle(theme)}>{title}</h1>
                          <p css={styles.mobileDescription(theme)}>{text}</p>
                        </div>
                        <div
                          className="MarketingFeature-image"
                          style={{ backgroundImage: imageUrl ? `url('${imageUrl}')` : undefined }}
                        />
                      </div>
                    </a>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
